import { useState } from "react";

const useFilter = (
  refundableFare,
  checkedbaggage,
  satyamSpecial,
  stops,
  cabinType,
  flight,
  officeId
) => {
  const [allFilters, setAllFilters] = useState([
    {
      label: "Office ID",
      labelKey: "filters.officeId",
      key: "officeId",
      permission: "Administrator",
      defaultOption: "",

      options: [
        {
          id: 1,
          value: "PBM1S23CL",
          key: "PBM1S23CL",
          checked: officeId === "PBM1S23CL",
        },
        {
          id: 2,
          value: "AMSN222SH",
          key: "AMSN222SH",
          checked: officeId === "AMSN222SH",
        },
      ],
    },
    {
      label: "Refundable Fare",
      labelKey: "filters.refundableFare",
      key: "refundableFare",
      defaultOption: false,
      options: [
        {
          value: "Refund Fare",
          labelKey: "filters.refundFare",
          checked: refundableFare ?? false,
          key: refundableFare ?? false,
        },
      ],
    },
    {
      label: "Baggage",
      labelKey: "filters.baggage",
      multiple: true,
      options: [
        {
          value: "Checked baggage",
          labelKey: "filters.checkedBaggage",
          checked: checkedbaggage ?? false,
          key: checkedbaggage ?? false,
          defaultOption: false,
        },
        {
          value: "2x Checked baggage",
          labelKey: "filters.twoCheckedBaggage",
          checked: satyamSpecial === "NEGOTIATED",
          key: "PUBLISHED",
          defaultOption: "PUBLISHED",
        },
      ],
    },

    {
      label: "Cabin Type",
      labelKey: "filters.cabinType",
      key: "cabinType",
      defaultOption: "",
      options: [
        {
          id: 1,
          value: "Economy",
          labelKey: "filters.economy",
          key: "ECONOMY",
          checked: false,
        },
        {
          id: 2,
          value: "Premium Economy",
          labelKey: "filters.premiumEconomy",
          key: "PREMIUM_ECONOMY",
          checked: cabinType === "PREMIUM_ECONOMY",
        },
        {
          id: 3,
          value: "Business",
          labelKey: "filters.business",
          key: "BUSINESS",
          checked: cabinType === "BUSINESS",
        },
        {
          id: 4,
          value: "First Class",
          labelKey: "filters.firstClass",
          key: "FIRST",
          checked: cabinType === "FIRST",
        },
      ],
    },
    {
      label: "Stops",
      labelKey: "filters.stops",
      key: "stops",
      defaultOption: 0,

      options: [
        {
          id: 1,
          value: "Non Stop(direct)",
          labelKey: "filters.nonStop",
          key: 0,
          checked: stops === 0,
        },
        {
          id: 2,
          value: "Up to 1 stop",
          labelKey: "filters.upToOneStop",
          key: 1,
          checked: false,
        },
        {
          id: 3,
          value: "Up to 2 stop",
          labelKey: "filters.upToTwoStops",
          key: 2,
          checked: stops === 2,
        },
      ],
    },
  ]);

  return { allFilters, setAllFilters };
};

export default useFilter;
